import { get } from "lodash"

const MEDIA_PADDING_BEFORE_MS = 5000;
const MEDIA_PADDING_AFTER_MS = 25000;

export const getMediaBoundariesForMention = ({mention, organization, paddingConfig}) => {
    let startDateTime, endDateTime;
    const mediaStartDateTime = new Date(mention.mediaStartTime * 1000);
    const mentionPadding = getMentionPadding(organization, paddingConfig);
    const prePaddingMs = mentionPadding.mentionPrePaddingMs;
    const postPaddingMs = mentionPadding.mentionPostPaddingMs;
    // changed hitStart/EndTime to airtime and collected_date for to new mediaSource graphQL calls
    const boundaryOps = {
        hitStartTime: mention.airtime,
        hitEndTime: mention.collected_date,
        prePaddingMs,
        postPaddingMs
    };
    const boundaries = getMediaBoundariesFromHitStartEnd(boundaryOps);
    startDateTime = boundaries.start;
    endDateTime = boundaries.end;
    const relativeStartEnd = getRelativeStartEndTimes({startDateTime, endDateTime, mediaStartDateTime});
    return {
        start: startDateTime.toISOString(),
        end: endDateTime.toISOString(),
        startSeconds: relativeStartEnd.startSeconds,
        endSeconds: relativeStartEnd.endSeconds
    };
}

const getMentionPadding = (organization, overridePadding) => {
    const overridePrePadding = overridePadding && overridePadding.mentionPrePaddingSeconds;
    const overridePostPadding = overridePadding && overridePadding.mentionPostPaddingSeconds;
    const orgPrePadding = get(organization, "kvp.features.mentionPrePaddingSeconds", MEDIA_PADDING_BEFORE_MS / 1000);
    const orgPostPadding = get(organization, "kvp.features.mentionPostPaddingSeconds", MEDIA_PADDING_AFTER_MS / 1000);
    return {
        mentionPrePaddingMs: orgPrePadding && getPaddingMs(MEDIA_PADDING_BEFORE_MS, orgPrePadding, overridePrePadding),
        mentionPostPaddingMs: orgPostPadding && getPaddingMs(MEDIA_PADDING_AFTER_MS, orgPostPadding, overridePostPadding)
    };
}

const getMediaBoundariesFromHitStartEnd = ({hitStartTime, hitEndTime, prePaddingMs, postPaddingMs}) => {
    const hitStartDateTime = new Date(hitStartTime);
    const hitEndDateTime = new Date(hitEndTime);
    const startDateTime = new Date(hitStartDateTime.valueOf() - prePaddingMs);
    const endDateTime = new Date(hitEndDateTime.valueOf() + postPaddingMs);
    return {
        start: startDateTime,
        end: endDateTime
    };
}

const getRelativeStartEndTimes = ({startDateTime, endDateTime, mediaStartDateTime}) => {
    const startSeconds = (startDateTime.valueOf() - mediaStartDateTime.valueOf()) / 1000;
    const durationSeconds = (endDateTime.valueOf() - startDateTime.valueOf()) / 1000;
    const endSeconds = startSeconds + durationSeconds;

    return {
        startSeconds,
        endSeconds
    };
}

const getPaddingMs = (defaultPaddingMs, orgPaddingSeconds, overridePaddingSeconds) => {
    const overridePaddingMs = overridePaddingSeconds && Number(overridePaddingSeconds) * 1000;
    const orgCustomPaddingMs = orgPaddingSeconds && Number(orgPaddingSeconds) * 1000;
    let paddingMs = defaultPaddingMs;
    if (!isNaN(overridePaddingMs)) {
        paddingMs = overridePaddingMs;
    } else if (!isNaN(orgCustomPaddingMs)) {
        paddingMs = orgCustomPaddingMs;
    }
    return paddingMs;
}
